import { Directive, ElementRef, Input, HostListener, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class DigitOnlyDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        this.decimalCounter = 0;
        this.navigationKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'Clear',
            'Copy',
            'Paste'
        ];
        this.decimal = false;
        this.decimalSeparator = '.';
        this.inputElement = el.nativeElement;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown(e) {
        if (this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
            (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
            (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
            (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
            (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
            (e.key === 'x' && e.metaKey === true) || // Allow: Cmd+X (Mac)
            (this.decimal && (e.key === this.decimalSeparator) && this.decimalCounter < 1) // Allow: only one decimal point
        ) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.key === ' ' || isNaN(Number(e.key))) {
            e.preventDefault();
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyUp(e) {
        if (!this.decimal) {
            return;
        }
        else {
            this.decimalCounter = this.el.nativeElement.value.split(this.decimalSeparator).length - 1;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onPaste(event) {
        /** @type {?} */
        const pastedInput = event.clipboardData.getData('text/plain');
        this.pasteData(pastedInput);
        event.preventDefault();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDrop(event) {
        /** @type {?} */
        const textData = event.dataTransfer.getData('text');
        this.inputElement.focus();
        this.pasteData(textData);
        event.preventDefault();
    }
    /**
     * @private
     * @param {?} pastedContent
     * @return {?}
     */
    pasteData(pastedContent) {
        /** @type {?} */
        const sanitizedContent = this.sanatizeInput(pastedContent);
        /** @type {?} */
        const pasted = document.execCommand('insertText', false, sanitizedContent);
        if (!pasted) {
            const { selectionStart: start, selectionEnd: end } = this.inputElement;
            this.inputElement.setRangeText(sanitizedContent, start, end, 'end');
        }
    }
    /**
     * @private
     * @param {?} input
     * @return {?}
     */
    sanatizeInput(input) {
        /** @type {?} */
        let result = '';
        if (this.decimal && this.isValidDecimal(input)) {
            /** @type {?} */
            const regex = new RegExp(`[^0-9${this.decimalSeparator}]`, 'g');
            result = input.replace(regex, '');
        }
        else {
            result = input.replace(/[^0-9]/g, '');
        }
        /** @type {?} */
        const maxLength = this.inputElement.maxLength;
        if (maxLength > 0) { // the input element has maxLength limit
            // the input element has maxLength limit
            /** @type {?} */
            const allowedLength = maxLength - this.inputElement.value.length;
            result = allowedLength > 0 ? result.substring(0, allowedLength) : '';
        }
        return result;
    }
    /**
     * @private
     * @param {?} string
     * @return {?}
     */
    isValidDecimal(string) {
        return string.split(this.decimalSeparator).length <= 2;
    }
}
DigitOnlyDirective.ɵfac = function DigitOnlyDirective_Factory(t) { return new (t || DigitOnlyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DigitOnlyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DigitOnlyDirective, selectors: [["", "digitOnly", ""]], hostBindings: function DigitOnlyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function DigitOnlyDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("keyup", function DigitOnlyDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); })("paste", function DigitOnlyDirective_paste_HostBindingHandler($event) { return ctx.onPaste($event); })("drop", function DigitOnlyDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
    } }, inputs: { decimal: "decimal", decimalSeparator: "decimalSeparator" } });
/** @nocollapse */
DigitOnlyDirective.ctorParameters = () => [
    { type: ElementRef }
];
DigitOnlyDirective.propDecorators = {
    decimal: [{ type: Input }],
    decimalSeparator: [{ type: Input }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    onKeyUp: [{ type: HostListener, args: ['keyup', ['$event'],] }],
    onPaste: [{ type: HostListener, args: ['paste', ['$event'],] }],
    onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DigitOnlyDirective, [{
        type: Directive,
        args: [{
                selector: '[digitOnly]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { decimal: [{
            type: Input
        }], decimalSeparator: [{
            type: Input
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    onPaste: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    DigitOnlyDirective.prototype.decimalCounter;
    /**
     * @type {?}
     * @private
     */
    DigitOnlyDirective.prototype.navigationKeys;
    /** @type {?} */
    DigitOnlyDirective.prototype.decimal;
    /** @type {?} */
    DigitOnlyDirective.prototype.decimalSeparator;
    /** @type {?} */
    DigitOnlyDirective.prototype.inputElement;
    /** @type {?} */
    DigitOnlyDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DigitOnlyModule {
}
DigitOnlyModule.ɵfac = function DigitOnlyModule_Factory(t) { return new (t || DigitOnlyModule)(); };
DigitOnlyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DigitOnlyModule });
DigitOnlyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DigitOnlyModule, { declarations: [DigitOnlyDirective], exports: [DigitOnlyDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DigitOnlyModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [DigitOnlyDirective],
                exports: [DigitOnlyDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DigitOnlyDirective, DigitOnlyModule };

//# sourceMappingURL=uiowa-digit-only.js.map